/* Discgolf.eu 2.0 – English port of the Discgolf.ee 2.x design-system layer. */
(function () {
  'use strict';
  var LABELS = ['Speed', 'Glide', 'Turn', 'Fade'];

  function parseMoney(el) {
    if (!el) return 0;
    var t = (el.textContent || '').replace(/[^\d,.\-]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    return parseFloat(t) || 0;
  }

  // USF cards: "5 | 4 | 0 | 2" -> four boxes (sibling element; Vue-owned nodes are never replaced),
  // "Allahindlus" -> "−X%". Re-checked on every USF re-render because Vue reuses card nodes.
  function enhanceCard(card) {
    var specs = card.querySelector('.indiv-product-specs:not(.dg-flight)');
    var src = specs ? specs.textContent.replace(/\u00a0/g, ' ').trim() : '';
    var box = card.querySelector('.dg-flight');
    if (specs && (!box || box.getAttribute('data-src') !== src)) {
      if (box) box.remove();
      var nums = src.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (nums.length >= 2) {
        var ul = document.createElement('ul');
        ul.className = 'dg-flight';
        ul.setAttribute('data-src', src);
        ul.setAttribute('aria-label', 'Flight numbers: ' + nums.join(', '));
        nums.slice(0, 4).forEach(function (n, i) {
          var li = document.createElement('li');
          li.innerHTML = '<span class="dg-flight__v"></span><span class="dg-flight__l">' + LABELS[i] + '</span>';
          li.firstChild.textContent = n;
          ul.appendChild(li);
        });
        var anc = card.querySelector('.hp-title > a'), mny = anc && anc.querySelector('.money-styling');
        if (mny) anc.insertBefore(ul, mny); else specs.parentNode.insertBefore(ul, specs.nextSibling);
        specs.classList.add('dg-hide');
      } else {
        specs.classList.add('dg-hide');
      }
    }
    var badge = card.querySelector('.sale-badge');
    var price = card.querySelector('.money-styling');
    if (badge && price) {
      var cmp = parseMoney(price.querySelector('.compare-at-price .money'));
      var monies = price.querySelectorAll(':scope > .money');
      var now = parseMoney(monies[monies.length - 1]);
      var txt = cmp > now && now > 0 ? '\u2212' + Math.round((cmp - now) / cmp * 100) + '%' : null;
      if (txt && badge.textContent !== txt) badge.textContent = txt;
    }
  }

  function scan() {
    document.querySelectorAll('#usf_container .indiv-product-wrapper').forEach(enhanceCard);
  }

  function watchUSF() {
    if (!document.querySelector('[id^=usf_]') || !('MutationObserver' in window)) return;
    var pending = false;
    // USF (Vue) can swap #usf_container itself, so observe the main element.
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; scan(); });
    }).observe(document.getElementById('main') || document.body, { childList: true, subtree: true, characterData: true });
    scan();
  }

  // Product page: mobile sticky add-to-cart bar (mirrors the real button; no own cart logic)
  function stickyATC() {
    var btn = document.getElementById('purchase');
    if (!btn) return;
    var titleEl = document.querySelector('.product-description-header') || document.querySelector('#product-box h1, #product-box h2');
    var priceEl = document.getElementById('price-field');
    var bar = document.createElement('div');
    bar.className = 'dg-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="dg-sticky-atc__info"><div class="dg-sticky-atc__title"></div><div class="dg-sticky-atc__price"></div></div>' +
      '<button type="button" class="dg-btn" tabindex="-1"></button>';
    bar.querySelector('.dg-sticky-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    var bBtn = bar.querySelector('button');
    function sync() {
      bar.querySelector('.dg-sticky-atc__price').textContent = priceEl ? priceEl.textContent.replace(/Ostukorv Vahesumma|Your Cart Subtotal/i, '').trim() : '';
      bBtn.textContent = btn.disabled ? (btn.textContent || '').trim() : 'Add to cart';
      bBtn.disabled = !!btn.disabled;
    }
    bBtn.addEventListener('click', function () { btn.click(); });
    document.body.appendChild(bar);
    sync();
    if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true });
    var ticking = false;
    function update() {
      ticking = false;
      var r = btn.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0 && r.height > 0);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }


  /* ===================== DG 2.3 – collection + PDP conversion layer ===================== */

  // --- helpers --------------------------------------------------------------------------
  var COLORS = { pink: 'Pink', blue: 'Blue', yellow: 'Yellow', orange: 'Orange', white: 'White', red: 'Red',
    purple: 'Purple', green: 'Green', turquoise: 'Turquoise', gray: 'Grey', grey: 'Grey', black: 'Black', brown: 'Brown',
    transparent: 'Clear', clear: 'Clear', 'light blue': 'Light blue', 'dark blue': 'Dark blue', gold: 'Gold',
    mint: 'Mint', silver: 'Silver', lime: 'Lime', 'light green': 'Light green', 'dark green': 'Dark green' };
  function colorName(v) {
    return String(v).split(/(\s*\/\s*|\s+-\s+)/).map(function (part) {
      var k = part.trim().toLowerCase();
      return COLORS[k] || part;
    }).join('').replace(/\s*\/\s*/g, ' / ').replace(/\s+-\s+/g, ' – ');
  }
  function weightName(v) {
    var s = String(v).trim(), m;
    if ((m = s.match(/^-\s*(\d{2,3})$/))) return 'Up to ' + m[1] + ' g';
    if ((m = s.match(/^\+?\s*(\d{2,3})\s*\+?$/)) && /\+/.test(s)) return m[1] + ' g and heavier';
    if ((m = s.match(/^(\d{2,3})\s*-\s*(\d{2,3})$/))) return m[1] + '–' + m[2] + ' g';
    if (/^random$/i.test(s)) return 'Random weight';
    return s;
  }
  function isColorOpt(n) { n = String(n).toLowerCase(); return /colou?r|värv/.test(n); }
  function isWeightOpt(n) { n = String(n).toLowerCase(); return /weight|kaal/.test(n); }
  function optLabel(n) { return isColorOpt(n) ? 'Colour' : isWeightOpt(n) ? 'Weight' : /denomination/i.test(n) ? 'Amount' : n; }
  function moneyLabel(v) { var m = String(v).match(/^€\s?(\d+)(?:[.,]00)?$/); return m ? '€' + m[1] : v; }
  function valueLabel(n, v) { return isColorOpt(n) ? colorName(v) : isWeightOpt(n) ? weightName(v) : moneyLabel(v); }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  // --- add-to-cart confirmation (one toast for PDP + cards; no modal, no auto-redirect) ---
  var toast, toastTimer;
  function showAdded(title, variantTitle) {
    if (window.__dgDrawer) { window.__dgDrawer.open({ title: title }); return; }
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'dg-added';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
      toast.addEventListener('click', function (e) {
        if (e.target.closest('[data-dg-close]')) { e.preventDefault(); hide(); }
      });
    }
    function hide() { toast.classList.remove('is-open'); }
    toast.innerHTML = '<div class="dg-added__txt"><b>Added to cart</b><span>' + esc(title) +
      (variantTitle && !/default title/i.test(variantTitle) ? ' · ' + esc(String(variantTitle).split(' / ').map(function (x) { return weightName(colorName(x)); }).join(' / ')) : '') + '</span></div>' +
      '<div class="dg-added__btns"><button type="button" class="dg-btn dg-btn--ghost dg-btn--sm" data-dg-close>Continue shopping</button>' +
      '<a class="dg-btn dg-btn--blue dg-btn--sm" href="/cart">View cart</a></div>';
    requestAnimationFrame(function () { toast.classList.add('is-open'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hide, 9000);
  }
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-item-count-header--quantity, .cart-item-count, .cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      return cart;
    }).catch(function () {});
  }
  function addVariant(id, meta) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-DG-Quick': '1' },
      body: JSON.stringify({ id: +id, quantity: 1 })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        refreshCount();
        showAdded(item.product_title || (meta && meta.title), item.variant_title);
        track('dg_quick_add', { product_id: meta && meta.productId, variant_id: +id, list: meta && meta.list, position: meta && meta.position });
        return item;
      });
  }

  // PDP: the theme posts the form itself; listen for successful /cart/add calls that are not ours.
  (function hookThemeAdds() {
    if (!document.getElementById('add-to-cart-form')) return;
    function done(ok, body) {
      if (!ok) return;
      try { var j = typeof body === 'string' ? JSON.parse(body) : body; showAdded(j.product_title, j.variant_title); } catch (e) {
        var t = document.querySelector('.product-description-header'); showAdded(t ? t.textContent.trim() : '', '');
      }
    }
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var mine = init && init.headers && (init.headers['X-DG-Quick'] || (init.headers.get && init.headers.get('X-DG-Quick')));
        var p = of.apply(this, arguments);
        if (!mine && /\/cart\/add/.test(url)) p.then(function (r) { if (r.ok) r.clone().json().then(function (j) { done(true, j); }).catch(function () { done(true, null); }); });
        return p;
      };
    }
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__dgAdd = /\/cart\/add/.test(u || ''); return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (x.__dgAdd) x.addEventListener('load', function () { done(x.status >= 200 && x.status < 300, x.responseText); });
      return os.apply(this, arguments);
    };
  })();

  // --- variant picker (never auto-picks a colour or weight) -----------------------------
  // model: { title, productId, options:[name], variants:[{id, values:[...], available:bool}] }
  function openPicker(host, model, meta) {
    var old = host.querySelector('.dg-pick'); if (old) { old.remove(); return; }
    var avail = model.variants.filter(function (v) { return v.available; });
    if (!avail.length) return;
    if (avail.length === 1 && model.variants.length === 1) { return addVariant(avail[0].id, meta); }
    var sel = model.options.map(function () { return null; });
    var box = document.createElement('div');
    box.className = 'dg-pick';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Choose an option: ' + model.title);
    host.appendChild(box);
    function valuesFor(i) {
      var out = [];
      avail.forEach(function (v) {
        for (var k = 0; k < sel.length; k++) if (k !== i && sel[k] !== null && v.values[k] !== sel[k]) return;
        if (out.indexOf(v.values[i]) < 0) out.push(v.values[i]);
      });
      return out;
    }
    function match() {
      if (sel.some(function (x) { return x === null; })) return null;
      return avail.filter(function (v) { return v.values.every(function (x, k) { return x === sel[k]; }); })[0] || null;
    }
    function render() {
      // an option with exactly one possible value is not a choice; show it as fixed
      model.options.forEach(function (n, i) { var vs = valuesFor(i); if (vs.length === 1 && sel[i] === null) sel[i] = vs[0]; });
      var m = match();
      var h = '';
      model.options.forEach(function (n, i) {
        var vs = valuesFor(i);
        h += '<div class="dg-pick__row"><span class="dg-pick__l">' + esc(optLabel(n)) + (sel[i] !== null ? ': <b>' + esc(valueLabel(n, sel[i])) + '</b>' : '') + '</span><div class="dg-pick__vals">';
        vs.forEach(function (v) {
          h += '<button type="button" class="dg-pick__v' + (sel[i] === v ? ' is-on' : '') + '" aria-pressed="' + (sel[i] === v) + '" data-i="' + i + '" data-v="' + esc(v) + '">' + esc(valueLabel(n, v)) + '</button>';
        });
        h += '</div></div>';
      });
      h += '<div class="dg-pick__foot"><button type="button" class="dg-btn dg-btn--blue dg-btn--sm dg-pick__add"' + (m ? '' : ' disabled') + '>' +
        (m ? 'Add to cart' : 'Choose ' + model.options.filter(function (n, i) { return sel[i] === null; }).map(optLabel).slice(0, 1).join('').toLowerCase()) +
        '</button><button type="button" class="dg-pick__x" aria-label="Close">×</button></div><p class="dg-pick__msg" role="status" aria-live="polite"></p>';
      box.innerHTML = h;
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      if (b.classList.contains('dg-pick__x')) { box.remove(); return; }
      if (b.classList.contains('dg-pick__add')) {
        var m = match(); if (!m) return;
        b.classList.add('is-busy');
        addVariant(m.id, meta).then(function () { box.remove(); }).catch(function (j) {
          b.classList.remove('is-busy');
          box.querySelector('.dg-pick__msg').textContent = (j && (j.description || j.message)) || 'Could not add this item. Please try again.';
        });
        return;
      }
      var i = +b.getAttribute('data-i'), v = b.getAttribute('data-v');
      sel[i] = sel[i] === v ? null : v;
      // drop later choices that became impossible
      sel.forEach(function (x, k) { if (k !== i && x !== null && valuesFor(k).indexOf(x) < 0) sel[k] = null; });
      render();
    });
    render();
    var first = box.querySelector('.dg-pick__v'); if (first) first.focus({ preventScroll: true });
  }

  // model builders
  function modelFromShopifyJSON(p) {
    return { title: p.title, productId: p.id, options: (p.options || []).map(function (o) { return o.name || o; }),
      variants: p.variants.map(function (v) { return { id: v.id, values: v.options, available: !!v.available }; }) };
  }
  function modelFromUSF(p) {
    var opts = p.options || [];
    return { title: p.title, productId: p.id, options: opts.map(function (o) { return o.name; }),
      variants: (p.variants || []).map(function (v) {
        return { id: v.id, available: v.available > 0 || v.available === true || v.available <= -2147483648,
          values: (v.options || []).map(function (ix, k) { return opts[k] ? opts[k].values[ix] : ix; }) };
      }) };
  }

  // --- theme product cards (homepage rows, PDP recommendations) -------------------------
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-dg-quick]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var card = f.closest('.dg-card'), json = card && card.querySelector('script.product-grid-json');
    var p; try { p = JSON.parse(json.textContent); } catch (err) { f.submit(); return; }
    var list = (f.closest('[id]') || {}).id || 'card';
    var pos = Array.prototype.indexOf.call((card.parentNode.parentNode || card.parentNode).children, card.parentNode) + 1;
    openPicker(f, modelFromShopifyJSON(p), { title: p.title, productId: p.id, list: list, position: pos });
  });

  // --- USF collection cards: vendor, flight under title, colour dots, quick add ----------
  function usfProduct(card) {
    var el = card, i;
    for (i = 0; i < 4 && el; i++) { if (el.__vue__ && el.__vue__.product) return el.__vue__.product; el = el.firstElementChild; }
    return null;
  }
  function enhanceUSFCard(card, idx) {
    var p = usfProduct(card); if (!p) return;
    var inner = card.querySelector('.indiv-product'); if (!inner) return;
    if (inner.getAttribute('data-dg-pid') === String(p.id)) return;
    inner.setAttribute('data-dg-pid', p.id);
    inner.querySelectorAll('.dg-usf-x').forEach(function (n) { n.remove(); });
    var title = inner.querySelector('.hp-title');
    // colour dots (available colours only, max 5)
    var opts = p.options || [], ci = -1;
    opts.forEach(function (o, k) { if (ci < 0 && isColorOpt(o.name)) ci = k; });
    var foot = document.createElement('div');
    foot.className = 'dg-usf-foot dg-usf-x';
    var html = '';
    if (ci >= 0) {
      var seen = {}, names = [];
      (p.variants || []).forEach(function (v) { if (v.available > 0 || v.available <= -2147483648) { var n = opts[ci].values[v.options[ci]]; if (!seen[n]) { seen[n] = 1; names.push(n); } } });
      if (names.length) {
        html += '<span class="dg-dots" aria-label="' + names.length + ' colours available">';
        names.slice(0, 5).forEach(function (n) {
          var h = String(n).toLowerCase().split(/[\/\-]/)[0].trim().replace(/\s+/g, '-');
          html += '<i title="' + esc(colorName(n)) + '" style="background-color:' + esc(h.replace(/-/g, '')) + '"></i>';
        });
        if (names.length > 5) html += '<em>+' + (names.length - 5) + '</em>';
        html += '</span>';
      }
    }
    html += '<button type="button" class="dg-btn dg-btn--blue dg-btn--sm dg-usf-add">Add to cart<span class="visually-hidden">: ' + esc(p.title) + '</span></button>';
    foot.innerHTML = html;
    var money = inner.querySelector('.money-styling');
    (title || inner).appendChild(foot);
    foot.querySelector('.dg-usf-add').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      openPicker(foot, modelFromUSF(p), { title: p.title, productId: p.id, list: 'collection', position: idx + 1 });
    });
  }
  // facet labels: weight ranges and colour names in Estonian (display only; filter values stay the same)
  function labelFacets() {
    document.querySelectorAll('.usf-facet').forEach(function (f) {
      var labs = f.querySelectorAll('.usf-label'); if (!labs.length) return;
      var raws = Array.prototype.map.call(labs, function (l) {
        var n = l.firstChild; if (!n || n.nodeType !== 3) return null;
        return (n.__dgRaw && n.__dgLab === n.nodeValue) ? n.__dgRaw : n.nodeValue.trim();
      });
      var t = f.querySelector('.usf-title'), name = t ? t.textContent.trim().toLowerCase() : '';
      var isW = /kaal|weight/.test(name) || raws.every(function (r) { return r === null || /^(random|[-+]?\d{2,3}\+?|\d{2,3}\s*-\s*\d{2,3})$/i.test(r); });
      var isC = !isW && (/värv|colou?r/.test(name) || raws.filter(function (r) { return r && COLORS[String(r).toLowerCase()]; }).length >= Math.max(2, raws.length / 3));
      if (!isW && !isC) return;
      var fn = isW ? weightName : colorName;
      Array.prototype.forEach.call(labs, function (l, i) {
        var n = l.firstChild; if (!n || n.nodeType !== 3 || raws[i] === null) return;
        var lab = fn(raws[i]); n.__dgRaw = raws[i]; n.__dgLab = lab; if (n.nodeValue !== lab) n.nodeValue = lab;
      });
    });
  }
  // accessibility: names for icon-only controls (theme header + USF widgets)
  function a11y() {
    function name(el, label) { if (el && !el.getAttribute('aria-label') && !(el.textContent || '').trim()) el.setAttribute('aria-label', label); }
    var mb = document.querySelector('button.slide-menu-mobile');
    if (mb) { if (mb.getAttribute('aria-label') === 'Open') mb.setAttribute('aria-label', 'Open menu'); var ac = mb.getAttribute('aria-controls'); if (ac && !document.getElementById(ac)) mb.removeAttribute('aria-controls'); }
    document.querySelectorAll('a[href="/cart"]').forEach(function (a) { name(a, 'Cart'); });
    document.querySelectorAll('.usf-sr-inputbox input[name=q], input[name=q]').forEach(function (i) { if (!i.getAttribute('aria-label') && !i.id) i.setAttribute('aria-label', 'Search products'); });
    document.querySelectorAll('.usf-sr-inputbox button[type=submit]').forEach(function (b) { name(b, 'Search'); });
    document.querySelectorAll('select.usf-dropdown').forEach(function (s) { if (!s.getAttribute('aria-label')) s.setAttribute('aria-label', 'Sort products'); });
  }
  function scanUSF() { document.querySelectorAll('#usf_container .indiv-product-wrapper').forEach(enhanceUSFCard); labelFacets(); a11y(); }
  if (document.querySelector('[id^=usf_]') && 'MutationObserver' in window) {
    var pend = false;
    new MutationObserver(function () { if (pend) return; pend = true; setTimeout(function () { pend = false; scanUSF(); }, 60); })
      .observe(document.body, { childList: true, subtree: true });
    // measurement: card clicks (collection -> PDP CTR) and filter use
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#usf_container .indiv-product-wrapper a[href*="/products/"]');
      if (a) {
        var w = a.closest('.indiv-product-wrapper');
        var all = Array.prototype.slice.call(document.querySelectorAll('#usf_container .indiv-product-wrapper'));
        track('dg_card_click', { list: 'collection', position: all.indexOf(w) + 1, url: a.getAttribute('href').split('?')[0] });
      }
      var f = e.target.closest && e.target.closest('.usf-facet-value, .usf-c-slider, .usf-remove, .usf-clear-all, .dg-chip');
      if (f) {
        var fac = f.closest('.usf-facet'), t = fac && fac.querySelector('.usf-title');
        track('dg_filter_use', { facet: t ? t.textContent.trim() : (f.classList.contains('dg-chip') ? 'category' : 'other'), value: (f.textContent || '').trim().slice(0, 60) });
      }
    }, true);
  }

  // --- PDP: labels, colour names, weight labels, stock + sale sync -----------------------
  function pdp() {
    var form = document.getElementById('add-to-cart-form'); if (!form) return;
    var pj = document.querySelector('script.product-json'), product = null;
    try { product = JSON.parse(pj.textContent); } catch (e) {}
    var sets = form.querySelectorAll('.swatches-wrapper fieldset.swatch');
    sets.forEach(function (fs) {
      var lg = fs.querySelector('legend'); if (!lg) return;
      var raw = (lg.firstChild && lg.firstChild.nodeValue || '').trim() || lg.textContent.trim();
      fs.setAttribute('data-dg-opt', raw);
      var lab = document.createElement('span'); lab.className = 'dg-legend';
      if (lg.firstChild && lg.firstChild.nodeType === 3) lg.firstChild.nodeValue = '';
      lg.insertBefore(lab, lg.firstChild);
      fs.querySelectorAll('.swatch-element').forEach(function (el) {
        var v = el.getAttribute('data-value'), l = el.querySelector('label');
        if (isColorOpt(raw)) { if (l) l.setAttribute('aria-label', colorName(v)); var tt = el.querySelector('.tooltip'); if (tt) tt.textContent = colorName(v); }
        else if (isWeightOpt(raw) && l && l.firstChild && l.firstChild.nodeType === 3) { l.firstChild.nodeValue = weightName(v) + ' '; l.setAttribute('aria-label', weightName(v)); }
      });
    });
    var stock = document.querySelector('[data-dg-stock]'), save = document.querySelector('[data-dg-save]');
    var idSel = form.querySelector('select[name=id]');
    function sync() {
      sets.forEach(function (fs) {
        var raw = fs.getAttribute('data-dg-opt'), c = fs.querySelector('input:checked');
        fs.querySelector('.dg-legend').innerHTML = esc(optLabel(raw)) + (c ? ': <b>' + esc(valueLabel(raw, c.value)) + '</b>' : '');
      });
      if (!product || !idSel) return;
      var v = product.variants.filter(function (x) { return String(x.id) === String(idSel.value); })[0];
      if (!v) return;
      if (stock) { stock.textContent = v.available ? 'In stock – dispatched by the next business day' : 'This option is sold out'; stock.classList.toggle('is-out', !v.available); }
      if (save) {
        var on = v.compare_at_price > v.price;
        save.classList.toggle('hide', !on);
        save.textContent = on ? '−' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%' : '';
      }
    }
    form.addEventListener('change', function () { setTimeout(sync, 30); });
    if (idSel) new MutationObserver(function () { setTimeout(sync, 30); }).observe(idSel, { attributes: true, childList: true, subtree: true });
    sync();
    // GRAM Power Buttons: value only when the product description states "Power: X"
    var pw = document.querySelector('[data-dg-power]');
    if (pw && product) {
      var m = String(product.description || '').replace(/<[^>]+>/g, ' ').match(/Power:\s*([0-5](?:[.,]5)?)/i);
      if (m) {
        var v = parseFloat(m[1].replace(',', '.')), dots = '';
        for (var i = 1; i <= 5; i++) dots += '<i class="' + (v >= i ? 'is-on' : v >= i - 0.5 ? 'is-half' : '') + '"></i>';
        pw.innerHTML = '<span class="dg-power__l">Power</span><span class="dg-power__dots" aria-hidden="true">' + dots + '</span><span class="dg-power__v">' + m[1] + ' / 5</span>';
        pw.setAttribute('aria-label', 'GRAM Power ' + m[1] + ' / 5');
        pw.hidden = false;
      }
    }
    track('dg_pdp_view', { product_id: product && product.id, vendor: product && product.vendor });
  }

  // --- collection: category chips scroll active chip into view ---------------------------
  function chips() {
    var on = document.querySelector('.dg-chips .is-active');
    if (on && on.scrollIntoView) { var row = on.parentNode; row.scrollLeft = on.offsetLeft - 16; }
  }

  // --- content pages: click-to-load map + conversion events ------------------------------
  function pages() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('a, button'); if (!t) return;
      var href = t.getAttribute('href') || '', page = location.pathname;
      if (t.hasAttribute('data-dgp-map-load')) {
        var box = t.closest('[data-dgp-map]');
        if (box && !box.querySelector('iframe')) {
          var f = document.createElement('iframe');
          f.src = box.getAttribute('data-dgp-map'); f.title = 'Map: Kassi 12, Tallinn'; f.loading = 'lazy'; f.referrerPolicy = 'no-referrer-when-downgrade';
          box.innerHTML = ''; box.appendChild(f);
        }
      }
      if (/^tel:/.test(href)) track('dg_phone_click', { page: page });
      else if (/^mailto:/.test(href)) track('dg_email_click', { page: page, to: href.replace(/^mailto:|\?.*$/g, '') });
      else if (t.getAttribute('data-dg-track') === 'map') track('dg_map_click', { page: page });
      else if (t.getAttribute('data-dg-track') === 'shop') track('dg_shop_click', { page: page, url: href });
    });
    document.querySelectorAll('[data-dg-success]').forEach(function (el) {
      track('dg_' + el.getAttribute('data-dg-success') + '_submit', { page: location.pathname });
      var w = el.closest('[data-dg-form]'); if (w && w.scrollIntoView) w.scrollIntoView({ block: 'center' });
    });
  }


  /* ===================== DG 2.4 – cart page, mini cart, cross-sell ===================== */
  // All money values come from Shopify (/cart.js, section render). Nothing here calculates prices.
  var CT = {
    cart: 'Cart', added: 'Added to cart', empty: 'Your cart is empty.', emptyCta: 'Shop discs',
    subtotal: 'Subtotal', ship: 'Free DPD pick-up point delivery to Latvia and Lithuania. €5 to other EU countries.',
    checkout: 'Checkout', next: 'You can choose the delivery method on the next step.', cont: 'Continue shopping',
    remove: 'Remove', xs: 'You might also need', add: 'Add to cart', choose: 'Choose options', close: 'Close cart',
    qty: 'Quantity', less: 'Decrease quantity', more: 'Increase quantity', err: 'Something went wrong. Please try again.'
  };
  function getJSON(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
  function cartJSON() { return getJSON('/cart.js'); }
  function postJSON(u, body) {
    return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function changeLine(key, qty) { return postJSON('/cart/change.js', { id: key, quantity: qty }); }
  function imgUrl(u, w) { if (!u) return ''; u = String(u).replace(/^http:/, 'https:'); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function variantLabel(item) {
    if (item.product_has_only_default_variant || !item.options_with_values) return '';
    return item.options_with_values.map(function (o) { return valueLabel(o.name, o.value); }).join(' · ');
  }
  function setCount(n) {
    document.querySelectorAll('.cart-item-count-header--quantity, .cart-item-count, .cart-count').forEach(function (el) { el.textContent = n; });
  }
  function emitCart(cart) { try { document.dispatchEvent(new CustomEvent('dg:cart', { detail: cart })); } catch (e) {} }
  function translateVals(root) {
    root.querySelectorAll('[data-dg-val]').forEach(function (el) {
      if (el.__dgT) return; el.__dgT = 1;
      var k = el.getAttribute('data-dg-val');
      if (k === 'c') el.textContent = colorName(el.textContent);
      else if (k === 'w') el.textContent = weightName(el.textContent);
    });
  }

  // --- cross-sell: Shopify recommendations first, then an accessory collection as fallback --
  var ACC_RE = /muu varustus|varustus|accessor/i;
  var PRIORITY_RE = /mini|marker|towel|rätik|birdie ?bag|bogey ?bag|kott|scarf/i;
  var EXCLUDE_RE = /kinkekaart|gift card|mystery|starter set|delivery/i;
  var poolPromise = null;
  function normRec(p) { // /recommendations/products.json shape
    return { id: p.id, title: p.title, url: p.url, img: p.featured_image, price: p.price, type: p.type || '',
      options: (p.options || []).map(function (o) { return o.name || o; }),
      variants: (p.variants || []).map(function (v) { return { id: v.id, values: v.options || [], available: !!v.available, price: v.price }; }) };
  }
  function normColl(p) { // /collections/x/products.json shape (prices are strings in EUR)
    var vs = (p.variants || []).map(function (v) {
      return { id: v.id, values: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }), available: !!v.available, price: Math.round(parseFloat(v.price) * 100) };
    });
    var avail = vs.filter(function (v) { return v.available; });
    return { id: p.id, title: p.title, url: '/products/' + p.handle, img: p.images && p.images[0] && p.images[0].src, type: p.product_type || '',
      price: avail.length ? Math.min.apply(null, avail.map(function (v) { return v.price; })) : 0,
      options: (p.options || []).map(function (o) { return o.name || o; }), variants: vs };
  }
  function isAccessory(p, max) {
    return ACC_RE.test(p.type) && !EXCLUDE_RE.test(p.title) && p.price > 0 && p.price <= max && p.variants.some(function (v) { return v.available; });
  }
  function crossSell(cart, limit) {
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var cfg = readI18n();
    var coll = cfg.xsCollection || 'accessories';
    var recs = cart.items.slice(0, 3).map(function (i) {
      return getJSON('/recommendations/products.json?product_id=' + i.product_id + '&limit=8&intent=complementary').then(function (j) {
        var list = (j.products || []).map(normRec);
        if (list.length) return list.filter(function (p) { return p.variants.some(function (v) { return v.available; }); });
        return getJSON('/recommendations/products.json?product_id=' + i.product_id + '&limit=10&intent=related').then(function (k) {
          return (k.products || []).map(normRec).filter(function (p) { return isAccessory(p, 2000); });
        });
      }).catch(function () { return []; });
    });
    if (!poolPromise) poolPromise = getJSON('/collections/' + coll + '/products.json?limit=60').then(function (j) {
      return (j.products || []).map(normColl).filter(function (p) { return isAccessory(p, 1500); })
        .sort(function (a, b) { return (PRIORITY_RE.test(b.title) ? 1 : 0) - (PRIORITY_RE.test(a.title) ? 1 : 0); });
    }).catch(function () { return []; });
    recs.push(poolPromise);
    return Promise.all(recs).then(function (lists) {
      var seen = {}, out = [];
      var kinds = {};
      cart.items.forEach(function (i) { var k = kind({ title: i.product_title, id: i.product_id }); if (k.charAt(0) !== 'p') kinds[k] = 1; });
      function kind(p) { var t = p.title.toLowerCase(); return /towel|rätik/.test(t) ? 'towel' : /mini|marker/.test(t) ? 'mini' : /bag|kott/.test(t) ? 'bag' : /scarf|sall/.test(t) ? 'scarf' : 'p' + p.id; }
      lists.forEach(function (l) { l.forEach(function (p) { var k = kind(p); if (!inCart[p.id] && !seen[p.id] && !kinds[k] && out.length < limit) { seen[p.id] = 1; kinds[k] = 1; out.push(p); } }); });
      return out;
    });
  }
  function renderXS(listEl, products, where) {
    listEl.innerHTML = products.map(function (p, i) {
      var avail = p.variants.filter(function (v) { return v.available; });
      var one = avail.length === 1;
      return '<li class="dgx" data-i="' + i + '">' +
        '<a class="dgx__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(imgUrl(p.img, 160)) + '" width="80" height="80" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="dgx__b"><a class="dgx__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="dgx__p">' + (avail.some(function (v) { return v.price !== avail[0].price; }) ? 'From ' : '') + money(p.price) + '</span></div>' +
        '<button type="button" class="dg-btn dg-btn--ghost dg-btn--sm dgx__add" data-xs="' + i + '">' + (one ? CT.add : CT.choose) + '</button>' +
        '<div class="dgx__pick"></div></li>';
    }).join('');
    listEl.onclick = function (e) {
      var b = e.target.closest('[data-xs]'); if (!b) return;
      e.preventDefault();
      var p = products[+b.getAttribute('data-xs')];
      var meta = { title: p.title, productId: p.id, list: 'cross_sell_' + where, position: +b.getAttribute('data-xs') + 1 };
      track('dg_cross_sell_click', { product_id: p.id, where: where });
      var model = { title: p.title, productId: p.id, options: p.options, variants: p.variants };
      var host = b.closest('.dgx').querySelector('.dgx__pick');
      var av = p.variants.filter(function (v) { return v.available; });
      if (av.length === 1) { b.classList.add('is-busy'); addVariant(av[0].id, meta).catch(function () { b.classList.remove('is-busy'); }); }
      else openPicker(host, model, meta);
    };
  }
  var i18nCache = null;
  function readI18n() {
    if (i18nCache) return i18nCache;
    try { i18nCache = JSON.parse(document.getElementById('dgc-i18n').textContent); } catch (e) { i18nCache = {}; }
    return i18nCache;
  }

  // --- mini cart (opens after add-to-cart and from the header cart icon) -------------------
  var drawer = null;
  function onCartPage() { return !!document.querySelector('[data-dgc]'); }
  function buildDrawer() {
    var d = document.createElement('div');
    d.className = 'dgd';
    d.hidden = true;
    d.innerHTML = '<div class="dgd__ov" data-dgd-close></div>' +
      '<div class="dgd__p" role="dialog" aria-modal="true" aria-labelledby="dgd-t" tabindex="-1">' +
      '<div class="dgd__h"><h2 id="dgd-t" class="dgd__title">' + CT.cart + ' <span class="dgd__n"></span></h2>' +
      '<button type="button" class="dgd__x" data-dgd-close aria-label="' + CT.close + '"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>' +
      '<p class="dgd__ok" role="status" aria-live="polite" hidden></p>' +
      '<div class="dgd__body"><ul class="dgd__items" role="list"></ul>' +
      '<div class="dgd__empty" hidden><p>' + CT.empty + '</p><a class="dg-btn dg-btn--blue" href="/collections/discs">' + CT.emptyCta + '</a></div>' +
      '<section class="dgd__xs" hidden aria-labelledby="dgd-xs"><h3 id="dgd-xs" class="dgd__h3">' + CT.xs + '</h3><ul class="dgd__xsl" role="list"></ul></section></div>' +
      '<div class="dgd__f"><div class="dgd__sum"><span>' + CT.subtotal + '</span><b class="dgd__total"></b></div>' +
      '<p class="dgd__ship">' + CT.ship + '</p>' +
      '<a class="dg-btn dg-btn--blue dgd__go" href="/cart">' + CT.checkout + '</a>' +
      '<button type="button" class="dg-btn dg-btn--ghost dgd__cont" data-dgd-close>' + CT.cont + '</button>' +
      '<p class="dgd__next">' + CT.next + '</p></div></div>';
    document.body.appendChild(d);
    var lastFocus = null, timer;
    function close() {
      d.classList.remove('is-open');
      document.documentElement.classList.remove('dgd-lock');
      setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function itemHTML(it) {
      var v = variantLabel(it);
      return '<li class="dgd__it" data-key="' + esc(it.key) + '">' +
        '<a class="dgd__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 160)) + '" width="72" height="72" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="dgd__info"><a class="dgd__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (v ? '<span class="dgd__v">' + esc(v) + '</span>' : '') +
        '<div class="dgd__row"><div class="dgc-qty dgc-qty--sm" role="group" aria-label="' + CT.qty + '">' +
        '<button type="button" class="dgc-qty__b" data-step="-1" aria-label="' + CT.less + '">−</button>' +
        '<span class="dgc-qty__n" aria-live="polite">' + it.quantity + '</span>' +
        '<button type="button" class="dgc-qty__b" data-step="1" aria-label="' + CT.more + '">+</button></div>' +
        '<button type="button" class="dgc-remove" data-rm>' + CT.remove + '</button>' +
        '<span class="dgd__lp">' + (it.original_line_price !== it.final_line_price ? '<del>' + money(it.original_line_price) + '</del> ' : '') + money(it.final_line_price) + '</span></div>' +
        '<p class="dgd__msg" role="status" aria-live="polite"></p></div></li>';
    }
    function render(cart) {
      setCount(cart.item_count);
      d.querySelector('.dgd__n').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      d.querySelector('.dgd__items').innerHTML = cart.items.map(itemHTML).join('');
      d.querySelector('.dgd__total').textContent = money(cart.total_price);
      d.querySelector('.dgd__empty').hidden = cart.item_count > 0;
      d.querySelector('.dgd__f').hidden = cart.item_count === 0;
      var xs = d.querySelector('.dgd__xs');
      if (!cart.item_count) { xs.hidden = true; return; }
      crossSell(cart, 2).then(function (list) {
        if (!list.length) { xs.hidden = true; return; }
        renderXS(d.querySelector('.dgd__xsl'), list, 'drawer'); xs.hidden = false;
      });
    }
    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-dgd-close]')) { e.preventDefault(); close(); return; }
      var li = e.target.closest('.dgd__it'); if (!li) return;
      var key = li.getAttribute('data-key');
      var step = e.target.closest('[data-step]'), rm = e.target.closest('[data-rm]');
      if (!step && !rm) return;
      var q = +li.querySelector('.dgc-qty__n').textContent;
      var next = rm ? 0 : Math.max(0, q + +step.getAttribute('data-step'));
      li.classList.add('is-busy');
      changeLine(key, next).then(function (cart) { render(cart); emitCart(cart); if (next === 0) track('dg_cart_remove', { where: 'drawer' }); })
        .catch(function (j) { li.classList.remove('is-busy'); li.querySelector('.dgd__msg').textContent = (j && (j.description || j.message)) || CT.err; });
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(d.querySelectorAll('a[href],button:not([disabled]),input'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    d.querySelector('.dgd__go').addEventListener('click', function () { track('dg_drawer_checkout', {}); });
    return {
      open: function (added) {
        if (onCartPage()) { cartJSON().then(emitCart); return; }
        lastFocus = document.activeElement;
        var ok = d.querySelector('.dgd__ok');
        if (added && added.title) {
          ok.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg><span><b>' + CT.added + ':</b> ' + esc(added.title) + '</span>';
          ok.hidden = false;
        } else ok.hidden = true;
        cartJSON().then(function (cart) {
          render(cart);
          d.hidden = false;
          requestAnimationFrame(function () { d.classList.add('is-open'); document.documentElement.classList.add('dgd-lock'); d.querySelector('.dgd__p').focus({ preventScroll: true }); });
          track('dg_cart_drawer_open', { source: added ? 'add' : 'header', item_count: cart.item_count });
        }).catch(function () { location.href = '/cart'; });
        clearTimeout(timer);
      },
      close: close
    };
  }
  function cartDrawer() {
    if (!window.fetch || !window.Promise) return;
    drawer = buildDrawer();
    window.__dgDrawer = drawer;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest && e.target.closest('a[href="/cart"]');
      if (!a || onCartPage() || a.closest('.dgd') || !a.closest('#shopify-section-header, header, .site-header, .mobile-header')) return;
      e.preventDefault();
      drawer.open(null);
    });
  }

  // --- cart page --------------------------------------------------------------------------
  function cartPage() {
    var root = document.querySelector('[data-dgc]'); if (!root) return;
    var t = readI18n();
    translateVals(root);
    var form = root.querySelector('#cartform');
    if (!form) return;
    var pending = null;

    function refresh() {
      return fetch('/cart?section_id=template--cart', { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('[data-dgc-swap="items"]')) { location.reload(); return; }
        ['items', 'totals'].forEach(function (k) {
          var a = root.querySelector('[data-dgc-swap="' + k + '"]'), b = doc.querySelector('[data-dgc-swap="' + k + '"]');
          if (a && b) a.innerHTML = b.innerHTML;
        });
        var c = doc.querySelector('[data-dgc-count]'), cc = root.querySelector('[data-dgc-count]');
        if (c && cc) cc.textContent = c.textContent;
        var tot = doc.querySelector('[data-dgc-total]');
        if (tot) root.querySelectorAll('.dgc-bar [data-dgc-total]').forEach(function (el) { el.textContent = tot.textContent; });
        translateVals(root);
        return cartJSON().then(function (cart) { setCount(cart.item_count); loadXS(cart); return cart; });
      });
    }
    function setQty(li, q, isRemove) {
      var key = li.getAttribute('data-key');
      li.classList.add('is-busy');
      return changeLine(key, q).then(function () {
        if (isRemove) track('dg_cart_remove', { where: 'cart' });
        return refresh();
      }).catch(function (j) {
        li.classList.remove('is-busy');
        var m = li.querySelector('.dgc-item__msg'); if (m) m.textContent = (j && (j.description || j.message)) || CT.err;
        var inp = li.querySelector('[data-dgc-qty]'); if (inp) inp.value = li.getAttribute('data-qty');
      });
    }
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-dgc-step]'), rm = e.target.closest('[data-dgc-remove]');
      var li = e.target.closest('.dgc-item');
      if (li && (step || rm)) {
        e.preventDefault();
        var inp = li.querySelector('[data-dgc-qty]');
        if (rm) { setQty(li, 0, true); return; }
        var q = Math.max(0, (+inp.value || 0) + +step.getAttribute('data-dgc-step'));
        inp.value = q;
        clearTimeout(pending);
        pending = setTimeout(function () { setQty(li, q, q === 0); }, 350);
        return;
      }
      var un = e.target.closest('[data-dgc-uncode]');
      if (un) { e.preventDefault(); applyCodes(currentCodes().filter(function (c) { return c.toLowerCase() !== un.getAttribute('data-dgc-uncode').toLowerCase(); }), null); return; }
      if (e.target.closest('[data-dgc-code]')) { e.preventDefault(); addCode(); return; }
      if (e.target.closest('[data-dgc-goto]')) {
        e.preventDefault();
        var ship = document.getElementById('dgc-ship') || document.getElementById('dgc-sum');
        ship.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    root.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-dgc-qty]'); if (!inp) return;
      var li = inp.closest('.dgc-item');
      var q = Math.max(0, parseInt(inp.value, 10) || 0);
      setQty(li, q, q === 0);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.id === 'dgc-code') { e.preventDefault(); addCode(); }
      if (e.key === 'Enter' && e.target.matches('[data-dgc-qty]')) { e.preventDefault(); e.target.blur(); }
    });

    // discount codes (Shopify Cart API, same rules as checkout)
    function currentCodes() {
      return Array.prototype.map.call(root.querySelectorAll('[data-dgc-uncode]'), function (b) { return b.getAttribute('data-dgc-uncode'); });
    }
    var msgEl = root.querySelector('.dgc-disc__msg');
    function applyCodes(list, added) {
      return postJSON('/cart/update.js', { discount: list.join(',') }).then(function (cart) {
        var bad = null;
        if (added) {
          var hit = (cart.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === added.toLowerCase(); })[0];
          if (!hit || !hit.applicable) {
            bad = added;
            return postJSON('/cart/update.js', { discount: list.filter(function (c) { return c.toLowerCase() !== added.toLowerCase(); }).join(',') }).then(function () { return bad; });
          }
        }
        return bad;
      }).then(function (bad) {
        if (msgEl && added) {
          msgEl.className = 'dgc-disc__msg ' + (bad ? 'is-bad' : 'is-ok');
          msgEl.textContent = bad ? (t.codeBad || '') : (t.codeOk || '').replace('[code]', added.toUpperCase());
        } else if (msgEl) msgEl.textContent = '';
        track('dg_discount_apply', { ok: !bad, removed: !added });
        return refresh();
      }).catch(function () { if (msgEl) { msgEl.className = 'dgc-disc__msg is-bad'; msgEl.textContent = CT.err; } });
    }
    function addCode() {
      var inp = document.getElementById('dgc-code'); if (!inp) return;
      var code = inp.value.trim(); if (!code) { inp.focus(); return; }
      var list = currentCodes(); if (list.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) < 0) list.push(code);
      applyCodes(list, code).then(function () { inp.value = ''; });
    }

    // order note is saved to the cart right away (checkout is opened by the delivery app, not by a form post)
    var note = form.querySelector('#note'), noteT;
    if (note) note.addEventListener('input', function () {
      clearTimeout(noteT);
      noteT = setTimeout(function () { postJSON('/cart/update.js', { note: note.value }).catch(function () {}); }, 600);
    });

    // checkout guard: clear inline messages instead of browser alerts, before the delivery app handles the click
    var err = root.querySelector('[data-dgc-err]'), agree = document.getElementById('agree');
    if (agree) agree.addEventListener('change', function () { if (agree.checked && err) err.hidden = true; });
    var pw = document.getElementById('parcelyWidget');
    if (pw) ['click', 'change'].forEach(function (ev) { pw.addEventListener(ev, function () { setTimeout(function () { if (err && window.PARCELY_APP && window.PARCELY_APP.readyForCheckout) err.hidden = true; }, 1200); }); });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('#cart_submit'); if (!b) return;
      var msg = '', target = null;
      if (agree && !agree.checked) { msg = t.errTerms; target = agree.closest('.dgc-terms'); }
      else if (window.PARCELY_APP && window.PARCELY_APP.widgetLoaded && window.PARCELY_APP.readyForCheckout === false) { msg = t.errShip; target = document.getElementById('dgc-ship'); }
      if (msg) {
        e.preventDefault(); e.stopImmediatePropagation();
        err.textContent = msg; err.hidden = false;
        if (target) { target.classList.add('is-flag'); setTimeout(function () { target.classList.remove('is-flag'); }, 1600); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        track('dg_checkout_blocked', { reason: target && target.id === 'dgc-ship' ? 'delivery' : 'terms' });
        return;
      }
      err.hidden = true;
      track('dg_checkout_click', { source: 'cart' });
    }, true);

    // mobile sticky bar: visible while the checkout button is below the viewport
    var bar = root.querySelector('[data-dgc-bar]'), cta = root.querySelector('.dgc-cta-wrap');
    if (bar && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var r = en[0];
        var show = !r.isIntersecting && r.boundingClientRect.top > 0;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var btn = bar.querySelector('button'); if (btn) btn.tabIndex = show ? 0 : -1;
      }).observe(cta);
    }

    // cross-sell
    var xsBox = root.querySelector('[data-dgc-xs]'), xsTimer;
    function loadXS(cart) {
      if (!xsBox) return;
      clearTimeout(xsTimer);
      xsTimer = setTimeout(function () {
        crossSell(cart, 3).then(function (list) {
          if (!list.length) { xsBox.hidden = true; return; }
          renderXS(xsBox.querySelector('.dgc-xs__list'), list, 'cart'); xsBox.hidden = false;
        });
      }, 50);
    }
    try { loadXS(JSON.parse(document.getElementById('initial-cart').textContent)); } catch (e) {}
    document.addEventListener('dg:cart', function () { refresh(); });
  }

  function init() { watchUSF(); stickyATC(); pdp(); chips(); scanUSF(); a11y(); pages(); cartDrawer(); cartPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* DG: grammatical singular for "1 products" in USF result summaries */
(function () {
    function fix() {
        var nodes = document.querySelectorAll('.usf-sr-summary, .usf-load-more-text, [class*="usf-viewed"], [class*="usf-sr-paging"]');
        for (var i = 0; i < nodes.length; i++) {
            var el = nodes[i];
            var b = el.querySelector('b');
            var txt = el.textContent.replace(/\s+/g, ' ').trim();
            var isOne = (b && b.textContent.trim() === '1') || /of 1 products$/.test(txt);
            if (!isOne) continue;
            for (var j = 0; j < el.childNodes.length; j++) {
                var n = el.childNodes[j];
                if (n.nodeType === 3 && /\bproducts\b/.test(n.data)) n.data = n.data.replace(/\bproducts\b/, 'product');
            }
        }
    }
    var scheduled = false;
    var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () { scheduled = false; fix(); }, 30);
    });
    function start() { fix(); mo.observe(document.body, { childList: true, subtree: true, characterData: true }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* DG fix 12.10.2026 v3: avalehe kaartidel varvid uhel real, ulejaak +N (nagu USF) */
(function(){
var SEL='.dg-card .indiv-product__swatches';
function fit(s){var items=[].slice.call(s.querySelectorAll(':scope>div'));if(!items.length)return;var em=s.querySelector(':scope>em.dg-more');items.forEach(function(i){i.style.display=''});if(em)em.remove();if(s.scrollWidth<=s.clientWidth+1)return;em=document.createElement('em');em.className='dg-more';s.appendChild(em);var n=items.length;while(n>1&&s.scrollWidth>s.clientWidth+1){n--;items[n].style.display='none';em.textContent='+'+(items.length-n);}}
var ro=window.ResizeObserver?new ResizeObserver(function(es){es.forEach(function(e){fit(e.target)})}):null;
function init(){document.querySelectorAll(SEL).forEach(function(s){if(s.__dgfit)return;s.__dgfit=1;fit(s);if(ro)ro.observe(s)})}
if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
window.addEventListener('load',init);
var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(init,250)}).observe(document.documentElement,{childList:true,subtree:true});
})();
